import React from "react";
import DropdownList from "./DropdownList";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'


export default class Dropdown extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isShown: false,
            isInputShown: false,
            current: null,
            emptyOptionName: "Default",
            keyProp: "id",
            valueProp: "name",
            items: this.props.items,
            search: ""
        };
        this.handleItemClick = this.handleItemClick.bind(this);
        this.toggleDropDown = this.toggleDropDown.bind(this);
        this.showDropDown = this.showDropDown.bind(this);
        this.hideDropDown = this.hideDropDown.bind(this);
        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.focusOnInput = this.focusOnInput.bind(this);
        this.handleOuterClick = this.handleOuterClick.bind(this);
        this.defaultFilterCallback = this.defaultFilterCallback.bind(this);
    }

    toggleDropDown() {

        if (this.props.isDisabled) {
            return;
        }

        if (this.state.isShown) {
            this.hideDropDown();
        } else {
            this.showDropDown();
        }
    }

    showDropDown() {

        if (!this.state.isShown) {
            this.setState({
                              isShown: true,
                              isInputShown: true,
                          });
        }
    }

    hideDropDown() {

        if (this.state.isShown) {
            this.setState({
                              isShown: false,
                              isInputShown: false,
                              search: ""
                          });
        }
    }

    handleItemClick(item) {

        if (this.props.itemClick) {

            this.props.itemClick(item);
        }
        this.setState({current: item});
        this.toggleDropDown();
    }

    handleOuterClick(event) {

        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            this.hideDropDown();
        }
    }

    componentDidMount() {

        (this.props.document || document).addEventListener('click', this.handleOuterClick);
    }

    componentWillUnmount() {

        (this.props.document || document).removeEventListener('click', this.handleOuterClick);
    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    focusOnInput(node) {
        if (node) {
            node.focus();
        }
    }

    setFilter(event) {

        this.setState({search: event.target.value});
    }

    defaultFilterCallback(item, search) {

        const valueProp = (this.props.valueProp || this.state.valueProp);

        return item[valueProp].toLowerCase().indexOf(search.toLowerCase()) !== -1;
    }

    filter(item, search) {

        const filterCallback = (this.props.filterCallback) ? this.props.filterCallback : this.defaultFilterCallback;

        return filterCallback(item, search);
    }

    preventClosing(event) {

        event.preventDefault();
        event.stopPropagation();
    }

    render() {

        const isShown = this.state.isShown;
        const hasEmpty = !!(this.props.hasEmpty);
        const keyProp = (this.props.keyProp) ? this.props.keyProp : this.state.keyProp;
        const valueProp = (this.props.valueProp) ? this.props.valueProp : this.state.valueProp;
        const current = ('current' in this.props) ? this.props.current : this.state.current;
        const isInputShown = this.state.isInputShown;
        const items = this.props.items.filter(
            (item) => this.filter(item, this.state.search)
        );
        const emptyOptionName = (this.props.emptyOptionName) ? this.props.emptyOptionName : this.state.emptyOptionName;
        
        return (
            <div className="amt-widget-dropdown" ref={this.setWrapperRef}>
                <div className={`amt-widget-dropdown-current ${isShown ? "dropdown-shown" : ""}`}
                     onClick={this.toggleDropDown}>
                    {isInputShown ?
                     (<input className="amt-current-input" placeholder="" ref={this.focusOnInput} onClick={this.preventClosing} onInput={(e) =>
                         this.setFilter(e)}/>)
                                   : null}

                    <div style={isInputShown ? {display: "none"} : null} className="amt-current-text">
                        <div className="amt-current-text-wrap">
                            {(current)? current[ valueProp ] : emptyOptionName}
                        </div>
                    </div>
                    <span className="amt-widget-arrow" style={this.props.styled.arrow || {}}><FontAwesomeIcon icon="chevron-down"/></span></div>
                {isShown ? (
                    <DropdownList
                        key="dropdown"
                        keyProp={keyProp}
                        valueProp={valueProp}
                        items={items}
                        hasEmpty={hasEmpty}
                        emptyOptionName={emptyOptionName}
                        onClick={this.handleItemClick}
                        document={this.props.document}
                    />
                ) : (
                     null
                 )}
            </div>
        );
    }
}
